import { render } from "./BookingStatusBadge.vue?vue&type=template&id=7f5ccac3&scoped=true"
import script from "./BookingStatusBadge.vue?vue&type=script&lang=js"
export * from "./BookingStatusBadge.vue?vue&type=script&lang=js"

import "./BookingStatusBadge.vue?vue&type=style&index=0&id=7f5ccac3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5ccac3"]])

export default __exports__